var map = {
	"./MRT.png": 7982,
	"./MunchPoints.png": 5345,
	"./SURE2022.png": 8217,
	"./create-your-golf.png": 7859,
	"./crypto.png": 1520,
	"./dpm.png": 1872,
	"./portfolio.png": 4372,
	"./threejsfloat.png": 5435
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;